export const SET_CURRENT_COURSE = 'SET_CURRENT_COURSE';
export const CHANGE_LOADER_FOR_DESCRIPTION = 'CHANGE_LOADER_FOR_DESCRIPTION';

export const SET_DATA_FOR_ROULETTE = 'GET_DATA_FOR_ROULETTE';
export const CHANGE_LOADING_TO_ROULETTE = 'CHANGE_LOADING_TO_ROULETTE';

